module.exports = "\r\n<div id=\"DatasetMenu\">\r\n<h2 md-dialog-title>Datasets</h2>\r\n<md-dialog-content>\r\n\r\n  <div id=\"datasetList\"></div>\r\n  <li *ngFor=\"let dataset of _MenuDataFull\">\r\n    <button md-button [md-dialog-close]=\"dataset\">{{ dataset.FullName }}</button>\r\n  </li>\r\n\r\n\r\n</md-dialog-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dataset-menu.html
// module id = 552
// module chunks = 1